export default __webpack_public_path__ + "static/media/xbox_card.7669915c.svg";